import React from 'react';
import LogudIkon from './LogudIkon';

const LogudKnap = () => {
	return (
		<div className="d-flex align-items-center">
			<a href="/logout" className="button button--reset d-flex align-items-center">
				<span style={ { marginRight: 8, paddingTop: 6 } } className="text-xs color-primary">Log af</span>
				<LogudIkon />
			</a>
		</div>
	);
};

export default LogudKnap;
